import e from "./atoms-v2752.js";
function o(a, r) {
  var t = Array.prototype.slice.call(r);
  return t.push(e), a.apply(this, t);
}
export {
  o as default
};
